/* import { withAuthenticationRequired } from '@auth0/auth0-react'; */
import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import { api } from "../../../services/api";
import Loading from '../../../components/Loading';
import { useTranslation } from 'react-i18next';
import './cuentas.css';
import { Button, Chip, ListItemIcon, ListItemText, Menu, MenuItem, Tooltip } from '@mui/material';
import { toast } from 'react-toastify';
import PagoTicModal from '../../../components/modales/PagoTicModal';
import PagoTIC from "../../../assets/pagotic-logo.jpg";
import PVS from "../../../assets/pvs-logo.jpg";
import MP from "../../../assets/mercadopago-logo.jpg";
import { AddLink, InfoOutlined, MoreVert, DeleteForever } from '@mui/icons-material';
import PVSModal from '../../../components/modales/PVSModal';
import ClickMacroModal from '../../../components/modales/ClickMacroModal';
import ClickMacro from "../../../assets/clickmacro-logo.jpg"
import withAuthenticationRequired from "../../../components/ProtectedRoutes/withAuthenticationRequired";

function VincularCuentas() {
  const [state, setState] = useState({
    showResult: false,
    apiMessage: "",
    error: null
  });
  const param = useParams();
  const [t] = useTranslation("global");
  const [loading, setLoading] = useState(false);
  const [loadingLink, setLoadingLink] = useState(false);
  const [vinculacion, setVinculacion] = useState(null);
  const [selectedAccountType, setSelectedAccountType] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [showPayPerTicModal, setShowPayPerTicModal] = useState(false);
  const [showPVSModal, setShowPVSModal] = useState(false);
  const [showClickModal, setShowClickModal] = useState(false);
  const handleClick = (event, type) => {
    setSelectedAccountType(type);
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const callApi = async (id) => {
    setLoading(true);
    try {
      const response = await api.eventoCuentas.getAll(id);

      if (response.status === "success") {
        setVinculacion(response.data.vinculacion);
      }
      else {
        throw new Error(response.message);
      }

    } catch (error) {
      setState({
        ...state,
        error: error.message
      });
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    document.title = `Carteras | PassGo`;
    callApi(param.id);
  }, [param.id]);

  const handleGenerateLink = async () => {
    setLoadingLink(true);

    try {
      const idevento = parseInt(param?.id);

      const response = await api.mercadopago.vincularCuenta({
        idevento: idevento,
      });

      if (response.status === "success") {
        window.location = response.data;
      }
    } catch (error) {
      setState({
        ...state,
        error: error
      });
    } finally {
      setLoadingLink(false);
    }
  }

  const handleDesvincular = async () => {
    if (!selectedAccountType) return;
    try {
      setLoadingLink(true);
      let response;

      switch (selectedAccountType) {
        case 'mercado_pago':
          response = await api.mercadopago.desvincularCuenta(param.id);
          break;
        case 'pagotic':
          response = await api.pagotic.unlinkCredential(param.id);
          break;
        case 'pvs':
          response = await api.pvs.unlinkCredential(param.id);
          break;
        case 'clickmacro':
          response = await api.clickmacro.unlinkCredential(param.id);
          break;
        default:
          throw new Error("Tipo de cuenta no reconocido");
      }
      if (response.status === "success") {
        toast.success("Cuenta desvinculada exitosamente");
        handleClose();
        callApi(param.id);
      }
    } catch (error) {
      toast.error(error.message || "Error al desvincular la cuenta");
    } finally {
      setLoadingLink(false);
    }
  }

  return (
    <>
      <div style={{ backgroundColor: "white", height: "100%", width: "100%", padding: "20px" }}>
        <div>
          <div className='d-flex flex-column align-items-center' style={{ gap: "30px" }}>
            <div className='d-flex flex-column flex-md-row align-items-center justify-content-between'
              style={{
                width: "100%", maxWidth: "700px", padding: "20px",
                border: `1px solid ${vinculacion?.mercado_pago ? '#8E8EFF' : `#CDD1D4`}`,
                backgroundColor: `${vinculacion?.mercado_pago ? '#E6E6FF' : '#FAFBFB'}`,
                borderRadius: "10px"
              }}>
              <div className='d-flex flex-row align-items-center' style={{ gap: window.innerWidth <= 768 ? "10px" : "20px" }}>
                <div>
                  <img src={MP} alt='mercado pago' style={{ width: "60px", height: "60px", borderRadius: "50%" }} />
                </div>
                <div className='d-flex flex-column' style={{ marginLeft: "20px" }}>
                  <p className='mb-0' style={{ display: "flex", alignItems: "centern", color: "#0B0060", fontSize: "16px", fontWeight: "600" }}>Cuenta de Mercado Pago
                    <Tooltip title="Asegurate de usar una cuenta a tu nombre o de tu organización para evitar rechazos.">
                      <InfoOutlined sx={{ fontSize: "16px", color: "#6C757D", marginLeft: "5px" }} />
                    </Tooltip></p>
                  {vinculacion?.mercado_pago ? (
                    <>
                      <p className='mb-0'>Titular: <span style={{ color: "black", fontWeight: "500" }}>{vinculacion?.titular}</span> </p>
                      <Chip label="Vinculado" style={{ fontFamily: "Bricolage Grotesque", backgroundColor: "#B6FECB", color: "#216735", width: "100px", height: "30px", fontSize: "13px", fontWeight: "500", marginTop: "10px" }} />
                    </>
                  ) : (
                    <Chip label="No vinculado" color="error" style={{ fontFamily: "Bricolage Grotesque", backgroundColor: "#F8C6C1", color: "#8C1C13", width: "110px", height: "30px", fontSize: "13px", fontWeight: "500", marginTop: "10px" }} />
                  )}
                </div>
              </div>
              <div className='mt-3 mt-md-0'>
                {vinculacion?.mercado_pago ? (
                  <>
                    <Button onClick={(e) => handleClick(e, 'mercado_pago')}><MoreVert /></Button>
                    <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
                      <MenuItem onClick={() => {
                        handleDesvincular('mercado_pago');
                      }}>
                        <ListItemIcon><DeleteForever fontSize="small" /></ListItemIcon>
                        <ListItemText>Desvincular</ListItemText>
                      </MenuItem>
                    </Menu>
                  </>
                ) : (
                  <MercadoPagoForm handleGenerateLink={handleGenerateLink} loadingLink={loadingLink} />
                )}

              </div>
            </div>

            <div className='d-flex flex-column flex-md-row align-items-center justify-content-between'
              style={{
                width: "100%", maxWidth: "700px", padding: "20px",
                border: `1px solid ${vinculacion?.pagotic ? '#8E8EFF' : `#CDD1D4`}`,
                backgroundColor: `${vinculacion?.pagotic ? '#E6E6FF' : '#FAFBFB'}`,
                borderRadius: "10px"
              }}>
              <div className='d-flex flex-row align-items-center' style={{ gap: window.innerWidth <= 768 ? "10px" : "20px" }}>
                <div>
                  <img src={PagoTIC} alt='pagotic' style={{ width: "60px", height: "60px", borderRadius: "50%" }} />
                </div>
                <div className='d-flex flex-column' style={{ marginLeft: "20px" }}>
                  <p className='mb-0' style={{ display: "flex", alignItems: "centern", color: "#0B0060", fontSize: "16px", fontWeight: "600" }}>Cuenta de PagoTIC
                    <Tooltip title="Asegurate de usar una cuenta a tu nombre o de tu organización para evitar rechazos.">
                      <InfoOutlined sx={{ fontSize: "16px", color: "#6C757D", marginLeft: "5px" }} />
                    </Tooltip></p>
                  {vinculacion?.pagotic ? (
                    <>
                      <p className='mb-0'>Nombre: <span style={{ color: "black", fontWeight: "500" }}>{vinculacion?.pagotic?.nombre}</span> </p>
                      <Chip label="Vinculado" style={{ fontFamily: "Bricolage Grotesque", backgroundColor: "#B6FECB", color: "#216735", width: "100px", height: "30px", fontSize: "13px", fontWeight: "500", marginTop: "10px" }} />
                    </>
                  ) : (
                    <Chip label="No vinculado" color="error" style={{ fontFamily: "Bricolage Grotesque", backgroundColor: "#F8C6C1", color: "#8C1C13", width: "110px", height: "30px", fontSize: "13px", fontWeight: "500", marginTop: "10px" }} />
                  )}
                </div>
              </div>
              <div className='mt-3 mt-md-0'>
                {vinculacion?.pagotic ? (
                  <>
                    <Button onClick={(e) => handleClick(e, 'pagotic')}><MoreVert /></Button>
                    <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
                      <MenuItem onClick={() => handleDesvincular('pagotic')}>
                        <ListItemIcon><DeleteForever fontSize="small" /></ListItemIcon>
                        <ListItemText>Desvincular</ListItemText>
                      </MenuItem>
                    </Menu>
                  </>
                ) : (
                  <>
                    <button type="button" style={{ backgroundColor: "#5656FF" }} onClick={() => setShowPayPerTicModal(true)} className="btn btn-primary my-3" disabled={loadingLink}><AddLink /> Vincular cuenta</button>
                    <PagoTicModal
                      open={showPayPerTicModal}
                      onClose={() => setShowPayPerTicModal(false)}
                      loading={loadingLink}
                    />
                  </>
                )}
              </div>
            </div>

            <div className='d-flex flex-column flex-md-row align-items-center justify-content-between'
              style={{
                width: "100%", maxWidth: "700px", padding: "20px",
                border: `1px solid ${vinculacion?.pvs ? '#8E8EFF' : `#CDD1D4`}`,
                backgroundColor: `${vinculacion?.pvs ? '#E6E6FF' : '#FAFBFB'}`,
                borderRadius: "10px"
              }}>
              <div className='d-flex flex-row align-items-center' style={{ gap: window.innerWidth <= 768 ? "10px" : "20px" }}>
                <div>
                  <img src={PVS} alt='PVS' style={{ width: "60px", height: "60px", borderRadius: "50%" }} />
                </div>
                <div className='d-flex flex-column' style={{ marginLeft: "20px" }}>
                  <p className='mb-0' style={{ display: "flex", alignItems: "centern", color: "#0B0060", fontSize: "16px", fontWeight: "600" }}>Cuenta de PVS
                    <Tooltip title="Asegurate de usar una cuenta a tu nombre o de tu organización para evitar rechazos.">
                      <InfoOutlined sx={{ fontSize: "16px", color: "#6C757D", marginLeft: "5px" }} />
                    </Tooltip></p>

                  {vinculacion?.pvs ? (
                    <>
                      <p className='mb-0'>Nombre: <span style={{ color: "black", fontWeight: "500" }}>{vinculacion?.pvs?.nombre}</span> </p>
                      <Chip label="Vinculado" style={{ fontFamily: "Bricolage Grotesque", backgroundColor: "#B6FECB", color: "#216735", width: "100px", height: "30px", fontSize: "13px", fontWeight: "500", marginTop: "10px" }} />
                    </>
                  ) : (
                    <Chip label="No vinculado" color="error" style={{ fontFamily: "Bricolage Grotesque", backgroundColor: "#F8C6C1", color: "#8C1C13", width: "110px", height: "30px", fontSize: "13px", fontWeight: "500", marginTop: "10px" }} />
                  )}
                </div>
              </div>
              <div className='mt-3 mt-md-0'>
                {vinculacion?.pvs ? (
                  <>
                    <Button onClick={(e) => handleClick(e, 'pvs')}><MoreVert /></Button>
                    <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
                      <MenuItem onClick={() => handleDesvincular('pvs')}>
                        <ListItemIcon><DeleteForever fontSize="small" /></ListItemIcon>
                        <ListItemText>Desvincular</ListItemText>
                      </MenuItem>
                    </Menu>
                  </>
                ) : (
                  <>
                    <button type="button" style={{ backgroundColor: "#5656FF" }} onClick={() => setShowPVSModal(true)} className="btn btn-primary my-3" disabled={loadingLink}><AddLink /> Vincular cuenta</button>
                    <PVSModal
                      open={showPVSModal}
                      onClose={() => setShowPVSModal(false)}
                      loading={loadingLink}
                    />
                  </>
                )}
              </div>
            </div>

            <div className='d-flex flex-column flex-md-row align-items-center justify-content-between'
              style={{
                width: "100%", maxWidth: "700px", padding: "20px",
                border: `1px solid ${vinculacion?.clickmacro ? '#8E8EFF' : `#CDD1D4`}`,
                backgroundColor: `${vinculacion?.clickmacro ? '#E6E6FF' : '#FAFBFB'}`,
                borderRadius: "10px"
              }}>
              <div className='d-flex flex-row align-items-center' style={{ gap: window.innerWidth <= 768 ? "10px" : "20px" }}>
                <div>
                  <img src={ClickMacro} alt='ClickMacro' style={{ width: "60px", height: "60px", borderRadius: "50%" }} />
                </div>
                <div className='d-flex flex-column' style={{ marginLeft: "20px" }}>
                  <p className='mb-0' style={{ display: "flex", alignItems: "centern", color: "#0B0060", fontSize: "16px", fontWeight: "600" }}>Cuenta de Click Macro
                    <Tooltip title="Asegurate de usar una cuenta a tu nombre o de tu organización para evitar rechazos.">
                      <InfoOutlined sx={{ fontSize: "16px", color: "#6C757D", marginLeft: "5px" }} />
                    </Tooltip></p>

                  {vinculacion?.clickmacro ? (
                    <>
                      <p className='mb-0'>Nombre: <span style={{ color: "black", fontWeight: "500" }}>{vinculacion?.clickmacro?.nombre}</span> </p>
                      <Chip label="Vinculado" style={{ fontFamily: "Bricolage Grotesque", backgroundColor: "#B6FECB", color: "#216735", width: "100px", height: "30px", fontSize: "13px", fontWeight: "500", marginTop: "10px" }} />
                    </>
                  ) : (
                    <Chip label="No vinculado" color="error" style={{ fontFamily: "Bricolage Grotesque", backgroundColor: "#F8C6C1", color: "#8C1C13", width: "110px", height: "30px", fontSize: "13px", fontWeight: "500", marginTop: "10px" }} />
                  )}
                </div>
              </div>
              <div className='mt-3 mt-md-0'>
                {vinculacion?.clickmacro ? (
                  <>
                    <Button onClick={(e) => handleClick(e, 'clickmacro')}><MoreVert /></Button>
                    <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
                      <MenuItem onClick={() => handleDesvincular('clickmacro')}>
                        <ListItemIcon><DeleteForever fontSize="small" /></ListItemIcon>
                        <ListItemText>Desvincular</ListItemText>
                      </MenuItem>
                    </Menu>
                  </>
                ) : (
                  <>
                    <button type="button" style={{ backgroundColor: "#5656FF" }} onClick={() => setShowClickModal(true)} className="btn btn-primary my-3" disabled={loadingLink}><AddLink /> Vincular cuenta</button>
                    <ClickMacroModal
                      open={showClickModal}
                      onClose={() => setShowClickModal(false)}
                      loading={loadingLink}
                    />
                  </>
                )}
              </div>
            </div>
          </div>
        </div>

      </div>
    </>
  )

}


function MercadoPagoForm({ handleGenerateLink, loadingLink }) {
  return (
    <div className='d-flex flex-row justify-content-end align-items-end w-100'>
      <button type="button" style={{ backgroundColor: "#5656FF" }} onClick={handleGenerateLink} className="btn btn-primary my-3" disabled={loadingLink}><AddLink style={{}} /> Vincular cuenta</button>
    </div>

  );
}

export default withAuthenticationRequired(VincularCuentas, {
  onRedirecting: () => <Loading />,
});